<script>
  export let value = "";

  import {Input} from 'sveltestrap';
</script>

<Input bind:value={value} />